/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box } from '@towersystems/towersystems-design-system';
import { compact } from 'lodash';
/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { isModalVisible } from 'state/ui/selectors';
import { stopEditingLocationGroup } from 'state/ui/location-group-modal/actions';
import { getLocationGroupId } from 'state/ui/location-group-modal/selectors';
import { getEditedLocationGroup } from 'state/location-groups/selectors';
import LocationGroupForm from 'blocks/location-group-form';
import { deleteLocationGroup } from 'state/location-groups/actions';
import {successNotice} from 'state/notices/actions';

/**
 * Style dependencies
 */
import './styles.scss';

const EditLocationGroupModal = ({ locationGroupId, locationGroup, connectionLocations, connectionId, isVisible, disabled, disabledExternalLocation, close, ...props }) => {
    const [submitting, setSubmitting] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const isNew = !locationGroupId;
    const title = isNew ? 'Create inventory group' : 'Edit inventory group';

    const handleDelete = async () => {
        if (isNew) {
            return;
        }
        setDeleting(true);
        try {
            await props.deleteLocationGroup(locationGroupId);
            close();
        } catch (error) {}
        setDeleting(false);
    };

    const buttons = compact([
        {
            key: 'cancel',
            label: 'Cancel',
            onClick: close,
        },
        !isNew && {
            key: 'delete',
            label: deleting ? 'Deleting' : 'Delete',
            onClick: handleDelete,
        },
        {
            key: 'save',
            label: submitting ? 'Saving' : 'Save',
            form: 'location-group-form',
            type: 'submit',
            disabled: submitting,
            primary: true,
        },
    ]);

    const onSuccess = () => {
        close();
        props.successNotice('Saved');
    }

    return (
        <Modal title={title} className='create-connection-modal' close={close} isVisible={isVisible} buttons={buttons}>
            <Box padding='xlarge'>
                <LocationGroupForm
                    locationGroupId={locationGroupId}
                    beforeSubmit={() => setSubmitting(true)}
                    afterSubmit={() => setSubmitting(false)}
                    afterSuccessfullSubmit={onSuccess}
                    locationGroup={locationGroup}
                    connectionLocations={connectionLocations}
                    connectionId={connectionId}
                    disabled={disabledExternalLocation}
                />
            </Box>
        </Modal>
    );
};

export default connect(
    (state) => ({
        isVisible: isModalVisible('EditLocationGroupModal')(state),
        locationGroupId: getLocationGroupId(state),
        locationGroup: getEditedLocationGroup(state, getLocationGroupId(state)) || {},
    }),
    {
        close: stopEditingLocationGroup,
        deleteLocationGroup,
        successNotice
    },
)(EditLocationGroupModal);
